import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from './api';
import {TaskStatusQueryKeys} from './tasks';
import {
  GenerateCampaigns,
  GetCampaignChat,
  GetCampaignChats,
  UpdateCampaigns,
} from '../../shared/api/definitions/chatabm';
import {ObjectId} from 'bson';

export const CampaignChatQueryKeys = {
  all: ['campaignChat'] as const,
  list: () => [...CampaignChatQueryKeys.all, 'list'],
  chat: (campaignChatId: ObjectId) =>
    [...CampaignChatQueryKeys.all, 'chat', campaignChatId.toString()] as const,
  campaign: (responseId: string) =>
    [...CampaignChatQueryKeys.all, 'campaign', responseId] as const,
};

export const useGetCampaignChats = createApiQuery(GetCampaignChats, () =>
  CampaignChatQueryKeys.list()
);

export const useGetCampaignChat = createApiQuery(
  GetCampaignChat,
  ({campaignChatId}) => CampaignChatQueryKeys.chat(campaignChatId)
);

export function useGenerateCampaigns() {
  const queryClient = useQueryClient();
  return useApiMutation(GenerateCampaigns, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TaskStatusQueryKeys.task('generateCampaigns'),
      });
    },
  });
}

export function useUpdateCampaigns() {
  return useApiMutation(UpdateCampaigns);
}
